// Utilidad para manejar errores de suscripción expirada
// Usar en los catch de las peticiones API
// Hook personalizado para manejar estado de suscripción
import { useState, useEffect } from 'react';
export const isSubscriptionExpiredError = (error: any): boolean => {
  // Verificar si el error es de suscripción expirada
  if (error?.response?.status === 403) {
    const data = error.response.data;
    return (
      data?.code === 'SUBSCRIPTION_EXPIRED' || 
      data?.message?.includes('suscripción ha vencido') ||
      data?.message?.includes('subscription expired')
    );
  }
  
  // También verificar si el error viene como string
  if (typeof error === 'string') {
    return error.includes('suscripción ha vencido') || 
           error.includes('subscription expired');
  }
  
  // Si el error tiene message
  if (error?.message) {
    return error.message.includes('suscripción ha vencido') || 
           error.message.includes('subscription expired');
  }
  
  return false;
};



export const useSubscriptionStatus = () => {
  const [isExpired, setIsExpired] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    checkSubscriptionStatus();
  }, []);

  const checkSubscriptionStatus = async () => {
    try {
      const userData = localStorage.getItem('user');
      if (!userData) {
        setIsChecking(false);
        return;
      }

      const user = JSON.parse(userData);
      
      // Verificar en el backend
      const response = await fetch(
        `${process.env.REACT_APP_API_URL || 'https://api.consultarapp.com'}/api/users/${user.id}/subscription-status`
      );

      if (response.status === 403) {
        const data = await response.json();
        if (data?.code === 'SUBSCRIPTION_EXPIRED') {
          setIsExpired(true);
        }
      }
    } catch (error) {
      console.error('Error verificando suscripción:', error);
    } finally {
      setIsChecking(false);
    }
  };

  const markAsExpired = () => {
    setIsExpired(true);
  };

  return { isExpired, isChecking, markAsExpired };
};